import { OUT_OF_SCOPE_REASON } from "@/lib/outOfScope";

/** Human label for a stored dismissal reason. Concept resets tag rows
 *  "reset:<reset id>" — an id, not something to show a user. */
export function formatExclusionReason(reason: string | null | undefined): string {
  if (!reason) return "—";
  if (reason.startsWith("reset:")) return "Hidden by reset";
  if (reason === OUT_OF_SCOPE_REASON) return "Outside your year range";
  return reason;
}
